import { render, staticRenderFns } from "./ShorexIntroList.vue?vue&type=template&id=42dbb24c&scoped=true"
import script from "./ShorexIntroList.vue?vue&type=script&lang=js"
export * from "./ShorexIntroList.vue?vue&type=script&lang=js"
import style0 from "./ShorexIntroList.vue?vue&type=style&index=0&id=42dbb24c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42dbb24c",
  null
  
)

export default component.exports